export enum UserRole {
	user = 'user',
	admin = 'admin',
  owner = 'owner',
  read_only = 'read_only'
}